<template>
  <div class="store-layout min-h-screen flex flex-col bg-gray-50">
    <!-- Navigation -->
    <GlobalNavbarNext />

    <!-- Main Content -->
    <main class="flex-1">
      <router-view />
    </main>

  <!-- Footer -->
    <HomeFooterComponent />

    <!-- End of the page: Gruľko lies under the footer, whose colour fades into the page background behind him
         (not on mobile in Sprievodca, its bottom bar sits there) -->
    <div class="bg-gradient-to-b from-brand-800 to-gray-50" :class="{ 'hidden lg:block': isGuide }">
      <img src="@brand/assets/pig_end.png" alt="" aria-hidden="true" width="1997" height="787" loading="lazy"
        class="block mx-auto w-full max-w-[1997px] h-auto pointer-events-none select-none">
    </div>

    <!-- Mobile tab bar -->
    <BottomNavBar />
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import HomeFooterComponent from '@/components/nav/HomeFooterComponent.vue'
import GlobalNavbarNext from '@/components/nav/GlobalNavbarNext.vue'
import BottomNavBar from '@/components/nav/BottomNavBar.vue'

const route = useRoute()
const isGuide = computed(() => route.path === '/sprievodca' || route.path.startsWith('/sprievodca/'))
</script>

<style>
/* Height of the mobile tab bar; fixed bottom bars of the pages (e.g. the
   product detail add-to-cart bar) sit on top of it. Set on :root so the chat
   launcher, which App.vue renders outside this layout, sees it too */
:root:has(.store-layout) {
  --bottom-nav-height: calc(4rem + env(safe-area-inset-bottom));
}

.store-layout {
  padding-bottom: var(--bottom-nav-height);
}

@media (min-width: 64rem) {
  :root:has(.store-layout) {
    --bottom-nav-height: 0px;
  }
}
</style>
